import {array_fill} from "./functions";

export class IsEditFlags {

    private readonly names: string[];
    private readonly flags: boolean[];

    constructor(names: string[], flags: boolean[]) {
        if (names.length === 0 || names.length !== flags.length) {
            throw new Error('invalid');
        }
        this.names = names;
        this.flags = flags;
    }

    isAnyEdit(): boolean {
        return this.flags.findIndex(f => f) !== -1;
    }

    isEdit(name: string) {
        const i = this.names.indexOf(name);
        if (i === -1) {
            throw new Error('no name');
        }

        return this.flags[i];
    }

    clearAllEdit() {
        return new IsEditFlags(this.names, this._makeClearedFlags());
    }

    edit(name: string): IsEditFlags {
        const i = this.names.indexOf(name);
        if (i === -1) {
            throw new Error('no name');
        }

        const new_flags = this._makeClearedFlags();
        new_flags[i] = true;
        return new IsEditFlags(this.names, new_flags);
    }

    editPrev(): IsEditFlags {
        const i = this.flags.findIndex(f => f);
        const n = (i === -1 || i === 0) ? this.flags.length - 1 : (i - 1);

        const new_flags = this._makeClearedFlags();
        new_flags[n] = true;

        return new IsEditFlags(this.names, new_flags);
    }

    editNext(): IsEditFlags {
        const i = this.flags.findIndex(f => f);
        const n = (i === -1) ? 0 : (i + 1) % this.flags.length;

        const new_flags = this._makeClearedFlags();
        new_flags[n] = true;

        return new IsEditFlags(this.names, new_flags);
    }

    private _makeClearedFlags(): boolean[] {
        return array_fill(false, this.flags.length);
    }

    static createFromNames(names: string[]) {
        return new IsEditFlags(Array.from(names), array_fill(false, names.length));
    }
}
